// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1N1ey","input":"styles_input__2obGa"};